import service from '@/utils/server';

const modName='/md/loveProduct/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};


export const materielEdit = data => {
  return service({
    url: modName + 'materielEdit/' + data.id,
    method: 'post'
  });
};

//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/md/loveProduct/api/index.js